export const selectProjects = (state) => state.companyProject?.projects || [];

export const selectProjectLoading = (state) =>
  state.companyProject?.loading || false;

export const selectProjectError = (state) =>
  state.companyProject?.error || null;

export const selectSelectedProject = (state) =>
  state.companyProject?.selectedProject || null;

export const selectProjectUpdating = (state) =>
  state.companyProject?.updating || false;

export const selectProjectDeleting = (state) =>
  state.companyProject?.deleting || false;

export const selectProjectPagination = (state) =>
  state.companyProject?.pagination || {};
